import { Stack } from '@montugroup/design-system';
import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

export const StyledPrescriptionDetails = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),

  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(4),
  },
}));

export const StyledDescriptionList = styled('dl')(({ theme }) => ({
  margin: 0,
  padding: 0,
  display: 'grid',
  gridTemplateColumns: '1fr',
  rowGap: theme.spacing(1),

  '& dt, & dd': {
    margin: 0,
  },

  '& dd + dt': {
    marginTop: theme.spacing(3),
  },

  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'max-content minmax(0, 1fr)',
    columnGap: theme.spacing(8),
    rowGap: theme.spacing(4),

    '& dd + dt': {
      marginTop: 0,
    },
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.info.main,
  textDecoration: 'underline',
  fontFamily: theme.typography.body1.fontFamily,
}));
